<template>



  <div class="card border-0" style="border-left: 1px solid #ccc !important;">
    <div class="card-body p-0">

      <h3 class="pt-4 px-5 m-0">
        {{ $t('login.registration.form.title') }}
      </h3>
      <hr>
    </div>
    <div class="card-body p-5">

              <div class="ps-form__group">
                <label for="registerName" class="ps-form__label">{{ $t('login.registration.form.name') }} *</label>
                <input
                    class="form-control ps-form__input p-3"
                    type="text"
                    id="registerName"
                    v-model="registerName"
                    required
                />
              </div>

              <div class="ps-form__group">
                <label for="registerEmail" class="ps-form__label">{{ $t('login.registration.form.email') }} *</label>
                <input
                    class="form-control ps-form__input p-3"
                    type="email"
                    id="registerEmail"
                    v-model="registerEmail"
                    required
                />
              </div>
              <div class="ps-form__group">
                <label for="registerPhone" class="ps-form__label">{{ $t('login.registration.form.phone') }} *</label>
                <input
                    class="form-control ps-form__input p-3"
                    type="tel"
                    id="registerPhone"
                    v-model="registerPhone"
                    required
                />
              </div>
              <div class="ps-form__group">
                <label for="registerPassword" class="ps-form__label">{{ $t('login.registration.form.password') }} *</label>
                <div class="input-group">
                  <input
                      class="form-control ps-form__input p-3"
                      v-model="registerPassword"
                      id="registerPassword"
                      :type="show1 ? 'text' : 'password'"
                      required
                  />
                  <div class="input-group-append">
                    <a class="input-group-text" href="#" @click.prevent="show1 = !show1">
                      <i class="fa fa-eye fa-2x"></i>
                    </a>
                  </div>
                </div>

              </div>
      <div class="ps-form__group">
        <input type="checkbox" id="specialDayEnabled" v-model="specialDaysEnabled">
        <label for="specialDayEnabled" class="ps-form__label ml-3">
          <strong>Xüsusi günlərimi qeyd etmək istəyirəm</strong>
        </label>
        <div class="text-dark small">
          Xüsusi günləriniz, məsələn, doğum gününüz, evlilik il dönümünüz və s. kimi günləri qeyd edə bilərsiniz.
          Bu günlərdə sizə xüsusi təkliflər göndərəcəyik.
          <br>
          <strong>Qeyd:</strong> Bu günlər yalnız sizin üçün qeyd olunur və başqaları ilə paylaşılmayacaq.
        </div>
      </div>


      <div v-if="specialDaysEnabled">
      <div class="card mt-3" v-for="(spec,index) in specialDayList" :key="index">
        <div class="card-body">

          <div class="mb-3">
            <label>Tarix *</label>
            <div class="input-group">
              <select class="form-control p-1" v-model="spec.day" required>
                <option v-for="d in 31" :key="d" :value="d">{{ d }}</option>
              </select>
              <select class="form-control form-control-sm" v-model="spec.month" required>
                <option :value="1">Yanvar</option>
                <option :value="2">Fevral</option>
                <option :value="3">Mart</option>
                <option :value="4">Aprel</option>
                <option :value="5">May</option>
                <option :value="6">İyun</option>
                <option :value="7">İyul</option>
                <option :value="8">Avqust</option>
                <option :value="9">Sentyabr</option>
                <option :value="10">Oktyabr</option>
                <option :value="11">Noyabr</option>
                <option :value="12">Dekabr</option>
              </select>

            </div>

          </div>
          <div class="mb-3">
            <label>Başlıq *</label>
            <div class="input-group">
            <input class="form-control" v-model="spec.title" required>
              <div class="input-group-append">
              <button type="button" class="btn btn-danger" @click.prevent="removeSpecItem(index)">
                <i class="fa fa-times fa-2x"></i>
              </button>
              </div>
            </div>
            <span class="text-muted small">Nümunə: Toy günü, Lalənin doğum günü</span>
          </div>

        </div>
      </div>

      <button class="btn btn-primary my-3" @click.prevent="addSpecialDay">
        <i class="fa fa-plus"></i>
        Yeni tarix
      </button>

      </div>


      <vue-turnstile :key="turnstileControl" site-key="0x4AAAAAAA7gyNJC5pNcsVAi" v-model="captcha" />

              <p v-if="registerError != null" class="alert alert-danger">
                {{ registerError }}
              </p>
              <div class="ps-form__submit">
                <button class="ps-btn ps-btn--warning mr-4" @click="handleLogin()">
                  {{ $t('login.registration.form.action') }}
                </button>
              </div>




          </div>


        </div>
</template>

<script>
import {useVuelidate} from '@vuelidate/core';
import {required, email, integer} from '@vuelidate/validators';
import {mapState} from "vuex";
import VueTurnstile from 'vue-turnstile';

export default {
  validations: {
    registerName: {required},
    registerPhone: {required, integer},
    registerEmail: {required, email},
    registerPassword: {required}
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      show1: false,
      registerName: null,
      registerPhone: null,
      registerEmail: null,
      registerPassword: null,
      captcha: null,
      turnstileControl: 1,
      specialDaysEnabled: false,
      specialDayList: [{
        month: null,
        day: null,
        title: null
      }],
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      registerError: state => state.auth.registerError
    }),/*
    registerNameErrors() {
      const errors = [];
      this.v$.$errors.forEach(function (error) {
            if (error.$property === "registerName") {
              if (error.$validator === 'required') {
                errors.push(this.$t('login.registration.form.fieldRequired'));
              }
            }
          }
      )
      return errors;
    },
    registerPhoneErrors() {
      const errors = [];
      this.v$.$errors.forEach(function (error) {
            if (error.$property === "registerPhone") {
              if (error.$validator === 'required') {
                errors.push(this.$t('login.registration.form.fieldRequired'));
              }
              if (error.$validator === 'integer') {
                errors.push(this.$t('login.registration.form.onlyNumbers'));
              }
            }
          }
      )
      return errors;
    },
    registerEmailErrors() {
      const errors = [];
      this.v$.$errors.forEach(function (error) {
            if (error.$property === "registerEmail") {
              if (error.$validator === 'email') {
                errors.push(this.$t('login.registration.form.wrongEmailFormat'));
              }
              if (error.$validator === 'required') {
                errors.push(this.$t('login.registration.form.fieldRequired'));
              }
            }
          }
      )
      return errors;
    },
    registerPasswordErrors() {
      const errors = [];
      this.v$.$errors.forEach(function (error) {
            if (error.$property === "registerPassword") {
              if (error.$validator === 'required') {
                errors.push(this.$t('login.registration.form.fieldRequired'));
              }
            }
          }
      )
      return errors;
    }*/
  },

  watch: {
    user(newValue) {
      if (newValue != null) {
        let l = localStorage.getItem("goBackAfterLogin");
        localStorage.removeItem("goBackAfterLogin")
        if (!l) {
          l = '/profile';
        }
        window.location.href = l;
      }
    }
  },
  methods: {
    handleLogin() {


        let name = this.registerName;
        let surname = '';

        if (this.registerName.indexOf(' ') > -1) {
          let p = name.split(' ');
          name = p[0];
          surname = p[1];
        }

        let params = {
          name: name, surname: surname,
          birthday: '', gender: 'm', phone: this.registerPhone,
          email: this.registerEmail, password: this.registerPassword,
          captcha: this.captcha
        };

        if(this.specialDaysEnabled) {
          params.specialDays = this.specialDayList.filter(item => item.month && item.day && item.title);
        } else {
          params.specialDays = [];
        }


        this.$store.commit('app/setLoading', true);
        this.$store.dispatch('auth/register', params);
        this.$store.commit('app/setLoading', false);
        setTimeout(() => {
          this.turnstileControl = this.turnstileControl + 1;
        }, 2000);
      },


    addSpecialDay(){
      this.specialDayList.push({
        month: null,
        day: null,
        title: null
      })
    },

    removeSpecItem(index) {
      if(this.specialDayList.length <= 1) {
         this.specialDaysEnabled = false;
        return;
      }
      this.specialDayList.splice(index, 1);
    },
  },
  components: {
    VueTurnstile
  }
}
;
</script>
